import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "../../store";
import { RewardState } from "@/store/reward/types";
import RewardApi from "@/utils/api/reward";

@Module({ dynamic: true, name: "reward", store })
class Reward extends VuexModule implements RewardState {
  public summaryData: RewardSummaryData = {
    lifetimeopenclosed: { timestamp: "", value: 0 },
    lifetimepaid: { timestamp: "", value: 0 },
    openearnings: { timestamp: "", value: 0 },
    paymentdue: { timestamp: "", value: 0 }
  };
  public localeInfo: LocaleInfo = null;
  public activityData: RewardActivityData[] = [];

  get dateRangeTotal() {
    let commission = 0;
    let payment = 0;
    this.activityData.forEach(item => {
      if (item.commission) commission += parseFloat(item.commission);
      if (item.payment) payment += parseFloat(item.payment);
    });

    return {
      commission,
      payment
    };
  }

  @Mutation
  public setRewardSummaryData(data: RewardSummaryData) {
    this.summaryData = data;
  }

  @Mutation
  public setLocaleInfo(data: LocaleInfo) {
    this.localeInfo = data;
  }

  @Mutation
  public setRewardActivityData(data: RewardActivityData[]) {
    this.activityData = data;
  }

  @Action({ commit: "setRewardSummaryData", rawError: true })
  public async getRewardSummaryData() {
    const response = await RewardApi.getSummaryData();
    return response;
  }

  @Action({ commit: "setLocaleInfo", rawError: true })
  public async getLocaleInfo() {
    const response = await RewardApi.getLocaleInfo();
    return response;
  }

  @Action({ commit: "setRewardActivityData", rawError: true })
  public async getRewardActivityData(payload: any) {
    const { startdate, enddate } = payload;
    const response = await RewardApi.getActivityData(
      startdate,
      enddate,
      this.localeInfo.currency
    );
    return response;
  }
}

export default getModule(Reward);
